import React from "react";
import { Redirect, Route } from "react-router";

import { getCookies, getUserData } from "../../utils/utilsFunctions";
import Error401 from "../Error401/Error401";

const PrivateRoutes = (props: any) => {
  const { Component, rest } = props;
  return (
    <Route
      {...rest}
      render={() =>
        !!getCookies() && !!getUserData() ? (
          <React.Fragment>
            <Component />
          </React.Fragment>
        ) : (
          <Redirect to={`/signin?redirect=${window.location.pathname}`} />
        )
      }
    />
  );
};


export const AdminPrivateRoutes = (props: any) => {
  const { Component, rest } = props;
  const user = !!getCookies() && !!getUserData() && JSON.parse(getUserData("user"));
  const userAdmin = user && user.role === 'admin';
  return (
    <Route
      {...rest}
      render={() =>
        !!userAdmin ? (
          <React.Fragment>
            <Component />
          </React.Fragment>
        ) : (
          <Error401 />
        )
      }
    />
  );
}

export default PrivateRoutes;
